import Image from 'next/legacy/image';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import DeliveryDetails from '@/components/checkDelivery/DeliveryDetails/DeliveryDetails';
// import DeliveryMap from '@/components/checkDelivery/DeliveryMap/DeliveryMap';
import PostcodeEntry from '@/components/checkDelivery/PostcodeEntry/PostcodeEntry';
import { Meta } from '@/layouts/Meta';
import { initializeStore } from '@/models/root-store';
import type { SeoData } from '@/shared/types';
import { Main } from '@/templates/Main';
import { getGeneralPageSeoData } from '@/utils/api-helpers';

type DeliveryProps = {
  seoData: SeoData;
};

// @ts-ignore
const Delivery: React.FC = ({ seoData }: DeliveryProps) => {
  const { register } = useForm();
  const [isShownDeliveryComp, setIsShownDeliveryComp] = useState(false);

  const [postalData, setPostalData] = useState<any>([]);

  const handleClick = (props: any) => {
    setIsShownDeliveryComp((current) => !current);
    setPostalData(props);
  };

  return (
    <Main
      meta={
        <Meta
          title={seoData?.seoTitle || 'Delivery Info'}
          description={seoData?.seoDescription || 'Delivery Info'}
          canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/delivery`}
        />
      }
      seoBlurb={seoData?.seoBlurb}
    >
      <div className={`mx-auto max-w-screen-xl`}>
        <div className="container px-0 md:px-2">
          <div
            className={'flex flex-col justify-center md:my-[72px] md:flex-row'}
          >
            <div className={`mb-8 w-full px-4 md:mb-0 md:w-[440px] md:px-0`}>
              {!isShownDeliveryComp && (
                <div>
                  <h1 className="mb-7 mt-10 font-interSemibold text-2xl leading-6 md:mt-16 md:leading-8 lg:text-4xl">
                    Enjoy high-protein meals, snacks, drinks, and more delivered
                    straight to your door.
                  </h1>
                  <p className="mb-12 font-inter text-base leading-[22px] lg:text-lg lg:leading-6">
                    Our high-protein ready-made meals are delivered to more than
                    4,500 suburbs Australia-wide, across Sydney, Melbourne,
                    Brisbane, Adelaide, Perth, Hobart, and many more.
                  </p>
                  <p
                    className={`mb-4 font-interMedium text-lg leading-6 text-rhubarb-dark lg:leading-7`}
                  >
                    Check if we deliver to you:
                  </p>
                  <div className="w-[326px]">
                    <PostcodeEntry
                      register={register}
                      handleClick={handleClick}
                      label="Postcode or Suburb"
                      placeholder="Eg. 2000"
                    />
                  </div>
                </div>
              )}
              {isShownDeliveryComp && (
                <>
                  <div
                    className={
                      'my-8 flex cursor-pointer font-interMedium text-lg md:mb-12 md:mt-0'
                    }
                    onClick={() => setIsShownDeliveryComp(false)}
                  >
                    <Image
                      id="back"
                      src="/assets/icons/go-back.svg"
                      alt="close"
                      width={20}
                      height={20}
                    />
                    <span className="pl-1 text-base">Go Back</span>
                  </div>
                  <DeliveryDetails
                    postalData={postalData}
                    isDeliveryPopup={false}
                  />
                </>
              )}
            </div>

            {/* <div
              className={`mt-8 h-[331px] bg-slate-300 md:mt-0 md:h-[530px] md:w-[600px]`}
            >
              <DeliveryMap
                postalData={postalData}
                isShownDeliveryComp={isShownDeliveryComp}
              />
            </div> */}
          </div>
        </div>
      </div>
    </Main>
  );
};

export async function getStaticProps() {
  const store = initializeStore({ ssr: true });
  const seoData: SeoData = await getGeneralPageSeoData(store, 'delivery-info');

  return {
    props: {
      seoData,
    },
  };
}

export default Delivery;
